import script from "./AnchorFloatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnchorFloatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AnchorFloatPanel.vue?vue&type=style&index=0&id=5e12f5f3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e12f5f3"]])

export default __exports__